import {
  array,
  boolean,
  number,
  object,
  type output,
  string,
} from 'zod';
import { isValidUrl } from '../../shared/functions';
import { emailAddressSchema } from './email-address.schema';

export const MAX_EMAIL_TITLE_LENGTH = 100;
export const MAX_BANNER_IMAGE_URL_LENGTH = 512;

const bannerImageUrlSchema = string()
  .max(MAX_BANNER_IMAGE_URL_LENGTH, {
    error: `Use ${MAX_BANNER_IMAGE_URL_LENGTH} characters or fewer for the banner image URL.`,
    abort: true,
  })
  .refine(isValidUrl, 'Enter a valid banner image URL.')
  .nullish();

export const emailTemplateRequestSchema = object({
  title: string().min(1, 'Enter an email title.').max(MAX_EMAIL_TITLE_LENGTH, `Use ${MAX_EMAIL_TITLE_LENGTH} characters or fewer for the email title.`),
  bannerImageUrl: bannerImageUrlSchema,
  bodyMessage: string().min(1, 'Enter a body message.'),
  sendOnDateTime: string().nullish(),
  sendOnTimeZone: string().nullish(),
  isSendNow: boolean(),
  targetGroupIds: array(number()),
  individualRecipients: array(emailAddressSchema),
});

export type EmailTemplateRequest = output<typeof emailTemplateRequestSchema>;

const emailTemplateRequestForSendingSchema = emailTemplateRequestSchema.superRefine((emailTemplate, context) => {
  if (emailTemplate.targetGroupIds.length === 0 && emailTemplate.individualRecipients.length === 0) {
    context.addIssue({
      code: 'custom',
      path: ['targetGroupIds'],
      message: 'Add at least one recipient.',
    });
    context.addIssue({
      code: 'custom',
      path: ['individualRecipients'],
      message: 'Add at least one recipient.',
    });
  }
});

export const getEmailTemplateRequestSchema = (isForSending: boolean) => {
  return isForSending
    ? emailTemplateRequestForSendingSchema
    : emailTemplateRequestSchema;
};
